import { useState } from 'react';
import { toast } from 'react-hot-toast';

import ButtonLoader from '../ButtonLoader';

const OnboardingPasswordReset = ({ isLoading, onSubmit }) => {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();

    if (newPassword !== confirmPassword) {
      toast.error('Passwords do not match');
      return;
    }

    onSubmit({ newPassword });
  }

  return (
    <>
      <form
        onSubmit={handleSubmit}
        className='flex flex-col gap-4'
      >
        <label className='flex flex-col gap-1'>
          <span>New Password</span>
          <input
            type="password"
            value={newPassword}
            onChange={e => setNewPassword(e.target.value)}
            required
          />
        </label>

        <label className='flex flex-col gap-1'>
          <span>Confirm new password</span>
          <input
            type="password"
            value={confirmPassword}
            onChange={e => setConfirmPassword(e.target.value)}
            required
          />
        </label>

        <div className='flex'>
          <button
            type="submit"
            className='bg-ase-blue h-[48px] px-4 font-semibold text-white rounded-md'
          >
            {isLoading ? <ButtonLoader /> : 'Update'}
          </button>
        </div>
      </form>
    </>
  )
}

export default OnboardingPasswordReset;
